import { ReactNode } from "react";

const Container = ({ children }: { children: ReactNode }) => {
  return (
    <div className="gap-4 p-4 md:gap-8 md:p-10">
      <div className="container grid gap-2">{children}</div>
    </div>
  );
};

export default Container;
